import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9965b830"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label", "aria-hidden"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    isOpen: { type: Boolean },
    ariaLabel: null,
    closeLabel: null
  },
  emits: ["close"],
  setup(__props: any, { expose }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {





const drawer = ref<HTMLElement | null>(null);
expose({ drawer });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["drawer-container", { 'drawer-container--open': __props.isOpen }])
  }, [
    _createElementVNode("button", {
      class: "overlay",
      type: "button",
      "aria-label": __props.closeLabel,
      tabindex: "-1",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, null, 8, _hoisted_1),
    _createElementVNode("aside", {
      id: "mobile-navigation-drawer",
      ref_key: "drawer",
      ref: drawer,
      class: "drawer",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": __props.ariaLabel,
      "aria-hidden": !__props.isOpen
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_2)
  ], 2))
}
}

})